import { StringMatch } from "../interfaces/key-value-dict";

export class TextHelpers {
  static convertToUpperCase(value: string): string {
    return value.toUpperCase();
  }

  static convertToTitleCase(value: string): string {
    return value.replace(
      /\w\S*/g,
      (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    );
  }

  static stringMatch(str1: string, str2: string): StringMatch {
    if (!str1 || !str2) { return 'invalid'; }
    return (
      str1.toLowerCase().replace(/\W+/g, '') ===
      str2.toLowerCase().replace(/\W+/g, '')
    );
  }
}
